import { AnimationShell } from '@/components';
import { cn } from '@/utils/styles';

import { CardsType } from './types';
import { HeaderCard } from './header-card';

export function HeaderCards({ info, asGroup = true }: CardsType) {
  const classNameAsIndividual =
    'grid w-full grid-cols-1 place-items-stretch gap-6 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4';

  const classNameAsGroup = cn(
    'grid w-full gap-4',
    'grid-cols-1',
    'md:grid-cols-2',
    'lg:grid-cols-4'
  );

  const cardWrapper = cn(
    'rounded-lg border border-neutral-50 bg-white p-4',
    'shadow-sm hover:shadow-md transition-shadow duration-200'
  );

  return (
    <AnimationShell type="opacity" className={asGroup ? classNameAsGroup : classNameAsIndividual}>
      {info.map(({ icon, title, value, className }, index) => (
        <div key={`${title}-${index}`} className={cardWrapper}>
          <HeaderCard icon={icon} title={title} value={value} className={className} asGroup={false} />
        </div>
      ))}
    </AnimationShell>
  );
}
